import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgIconModule } from '@commons/svg-icon/svg-icon.module';
import { TrackerModule } from '@commons/tracker/tracker.module';
import { I18nContractModule } from '@domains/jobs/i18n-contract/i18n-contract.module';
import { ListComponent } from '@domains/jobs/list/list.component';
import { StatusModule } from '@domains/jobs/status/status.module';

@NgModule({
  declarations: [ListComponent],
  imports: [CommonModule, SvgIconModule, I18nContractModule, RouterModule, StatusModule, TrackerModule],
  exports: [ListComponent],
})
export class ListModule {}
